/**
 * Created by eladd on 7/13/2017.
 */
import {
	AfterContentInit,
	ChangeDetectorRef,
	Component,
	ContentChild,
	ContentChildren,
	HostBinding,
	Input,
	OnChanges,
	QueryList,
	SimpleChanges,
	Output,
	EventEmitter, ViewChild, ElementRef
} from "@angular/core";
import {TabComponent} from "../tab.component/tab.component";
import * as _ from "lodash";

@Component({
	selector: 'cp-tabs-wrapper',
	templateUrl: './tabs.wrapper.component.html',
	styleUrls: ['./tabs.wrapper.component.scss']
})
export class TabsWrapperComponent implements AfterContentInit, OnChanges {
	@HostBinding('class.vertical')
	@Input() vertical : boolean;
	@HostBinding('class.classic')
	@Input() classic: boolean;
	@Input() tabTitleWidth: number;
	@Input() closedByDefault: boolean;
	@Input() allTabsClosed: boolean;
	@Input() disableTabChange: boolean;
	@Input() tabTitleAlignment: number;
	@Input() selectedTab: string;
	@Input() addRemoveButtons: boolean;

	@Output() selectedTabName = new EventEmitter<string>();
	@Output() addNew = new EventEmitter<any>();
	@Output() remove = new EventEmitter<TabComponent>();


	@ContentChildren(TabComponent) tabs: QueryList<TabComponent>;
	@ContentChild('tabTitleTemplate' ,{static:false}) public titleTplDirective;
	@ViewChild('tabsGroup', {read: ElementRef,static:false}) tabsGroupRef: ElementRef;

	constructor(private cd:ChangeDetectorRef){}

	ngAfterContentInit() {
		if (!this.closedByDefault) {
			if (!this.tabs.first.disabled) {
				this.tabs.first.active = true;
				this.tabs.first.onActivation.emit();
			}
		}
		if (this.selectedTab){
			this.selectTabByTitle(this.selectedTab);
		}
	}

	ngOnChanges(e: SimpleChanges) {
		if (e["allTabsClosed"] && !_.isEqual(e["allTabsClosed"].currentValue, e["allTabsClosed"].previousValue)) {
			if (this.allTabsClosed) {
				this.closeAllTabs();
			}
		}
	}

	// runs a lot. if we have performance issuces, may need to re-think this
	public findActive():{tab:TabComponent,index:number}{
		let active;
		this.tabs.forEach((curr,i)=>{
			if (curr.active){
				active= {
					tab:curr, index:i
				};
			}
		});
		return active;
	}
	public removeActive(){
		let currActive = this.findActive();
		this.remove.emit(currActive.tab);
		if (currActive.index>0){
			this.selectTab(this.tabs.get(currActive.index-1));
		}
	}

	public removeTabByTitle(tabTitle: string) {
		this.remove.emit(this.tabs.find(t=>t.tabTitle === tabTitle));
	}

	public setScrollByActiveItem() {
		let tabsGroupElm = this.tabsGroupRef.nativeElement;
		let elements = tabsGroupElm.getElementsByClassName("active");
		if (elements && elements.length > 0 && elements[0]) {
			let selectedLeft = elements[0].getClientRects()[0].left;
			let containerLeft = tabsGroupElm.getClientRects()[0].left;
			this.tabsGroupRef.nativeElement.scrollLeft = selectedLeft - containerLeft + tabsGroupElm.scrollLeft - tabsGroupElm.offsetHeight / 2;
		}
	}

	public hasScroll() {
		return this.tabsGroupRef?.nativeElement?.scrollWidth > this.tabsGroupRef?.nativeElement?.clientWidth;
	}

	selectTab(tab: TabComponent) {
		if (this.disableTabChange){
			return;
		}
		if (tab.active && this.closedByDefault) {
			tab.active = false;
			tab.onDeactivation.emit();
		} else {
			this.tabs.forEach(t => t.active = false);
			tab.active = true;
			tab.onActivation.emit();
			this.selectedTabName.emit(tab.tabTitle);
		}
	}

	selectTabByExtraData(extraData:any) {
		for (let t of this.tabs.toArray()) {
			if (t.extraData === extraData) {
				this.selectTab(t);
				break;
			}
		}
	}

	selectTabByTitle(tabTitle: string) {
		for (let t of this.tabs.toArray()) {
			if (t.tabTitle === tabTitle) {
				this.selectTab(t);
				break;
			}
		}
	}

	closeAllTabs() {
		if (this.tabs) {
			this.tabs.forEach(t => t.active = false);
		}
	}
}
